import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  src: _imports_0
}, null, -1)

import { ref } from "vue";
import HelloWorld from "./components/HelloWorld.vue";
import GlobalMixin from "./globalMixin";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const digit = ref(0);

const increment = () => {
  digit.value++;
};

const decrement = () => {
  digit.value--;
};

const writeTest = () => {
  return GlobalMixin.methods.test();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(HelloWorld, { msg: "Welcome to Your Vue.js + TypeScript App" }),
    _createElementVNode("h1", null, _toDisplayString(writeTest()), 1),
    _createElementVNode("button", { onClick: increment }, "+"),
    _createElementVNode("h1", null, _toDisplayString(digit.value), 1),
    _createElementVNode("button", { onClick: decrement }, "-")
  ], 64))
}
}

})